import { CallStatusErrorCode } from "./mediator/errorCodes"

export interface Endpoint {
  canConnect: boolean
  canDisconnect: boolean
  status: 'offline' | 'connecting' | 'online'
  statusError?: string
}

export interface Line {
  status: 'registered' | 'unregistered' | 'registering' | 'unregistering'
  statusError?: string
  canRegister: boolean
  canUnregister: boolean
  mwiStatus?: boolean
  username?: string
  displayName?: string
}

// be careful with incomingcall, their docs says incomingCall but sends incomingcall. (C's caseness)
export type CallStatusType = 'idle' | 'incomingcall' | 'connected' | 'reconnected' | 'callingOut' | 'ringingOut' | 'progressOut' | 'hold' | 'transferring'
// a lot of these are defined in janus.es.js.
export type VideoSourceType =
  | undefined       // used when disabling video
  | boolean         // defaults to 640x480
  | 'screen'        // desktop sharing
  | 'window'        // window sharing
  | 'lowres'        // 320x240
  | 'lowres-16:9'   // 320x180
  | 'hires'         // 1280x720
  | 'fhdres'        // 1920x1080
  | '4kres'         // 3840x2160
  | 'stdres'        // 640x480
  | 'stdres-16:9'   // 640x360

interface PtzCapability {
  min: number
  max: number
  step: number
}

export interface PtzSetting extends PtzCapability {
  current: number
}

export interface MediaTrackSettingsEx extends MediaTrackSettings {
  pan?: number
  tilt?: number
  zoom?: number
}

export interface MediaTrackCapabilitiesEx extends MediaTrackCapabilities {
  pan?: PtzCapability
  tilt?: PtzCapability
  zoom?: PtzCapability
}

export interface MediaTrackConstraintSetEx extends MediaTrackConstraintSet {
  pan?: number
  tilt?: number
  zoom?: number
}

export interface PtzFeature {
  pan?: PtzSetting
  tilt?: PtzSetting
  zoom?: PtzSetting
}

export interface Call {
  callId: string
  status: CallStatusType
  statusErrorCode?: CallStatusErrorCode
  statusErrorDescription?: string
  localStream?: MediaStream
  remoteStream?: MediaStream

  peerUsername: string
  peerDisplayName: string

  canDial: boolean
  canRingOut: boolean
  canHangUp: boolean
  canAnswer: boolean
  answerRequested: boolean
  featureHoldResume: boolean
  canHold: boolean
  canResume: boolean
  canBlindXfer: boolean
  canXfer: boolean
  canSendDtmf: boolean
  isMuted: boolean
  hasRemoteVideo: boolean
  hasLocalVideo: boolean
  videoSource: VideoSourceType
  ptz?: PtzFeature

  canPlayBusyTone: boolean
  canPlayReorderTone: boolean
  canPlayNuTone: boolean
  lastHangupCode: number

  isSlowAudioDownlink: boolean;
  isSlowAudioUplink: boolean;

  stats?: RTCStatsReport

  isScreenSharing: () => boolean
}

export function isCallConnected(call: Call): boolean {
  return call.status === 'connected' || call.status === 'reconnected'
}

export interface AutomationTestCommand {
  Command: 'connect' | 'disconnect' | 'auto-answer-mode'
  Extension: string // for connect
  Pin: string // for connect
  Settings: Settings // for connect
  ErrorReason: string
  Result?: boolean
}

export interface Settings {
  sipDomain?: string
  turnServer: string
  turnServerUdpPort: string
  turnServerTcpPort: string
  turnUsername?: string
  turnPassword?: string
  janus: string
  sipRealm?: string
  serverUsername?: string
  serverPassword?: string
}

export type HidDevice = {
  deviceId: string
  deviceName: string
  serialNumber: string
}
